export default __webpack_public_path__ + "static/media/sa.2ef0a2f1.svg";